<div class="content">

	<div  *ngIf="shown.grid" class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding: 10px;">

		<button class="btn" (click)="EntityForm()" mat-flat-button
			>Add </button>

      <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">

			<!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->
			<ng-container matColumnDef="Id">
				<th mat-header-cell *matHeaderCellDef>Id</th>
				<td mat-cell *matCellDef="let element">{{element.entityId}}</td>
			</ng-container>

			<!-- Position Column -->
			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
				<td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="Description">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
				<td mat-cell *matCellDef="let element">{{element.description}}</td>
			</ng-container>

			<ng-container matColumnDef="Edit">
				<th mat-header-cell *matHeaderCellDef>Edit</th>
				<td mat-cell *matCellDef="let element" (click)="editEntity(element.entityId)">
					<mat-icon appearance="outline" style="width:2%;color: green;cursor:pointer;font-size: 20px;">edit</mat-icon>
				</td>
			</ng-container>

			<ng-container matColumnDef="delete">
				<th mat-header-cell *matHeaderCellDef>Delete</th>
				<td mat-cell *matCellDef="let element;let i = index" (click)="deleteEntity(element.entityId,i)">
					<mat-icon appearance="outline" style="width:2%;color: red;cursor:pointer;font-size: 20px;">clear</mat-icon>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

		</table>
		<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
	</div>

<!-- Form Begin -->
<div *ngIf="shown.Form">
	<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
		<div class="loginbox">
			<form [formGroup]="Entity" class="example-form">
				<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
				<mat-form-field appearance="outline" class="example-full-width" style="width:100%">
					<input (keypress)="handleInput($event)" matInput placeholder="Name" formControlName="name" value="">
        </mat-form-field>
        <mat-error *ngIf="validator.UniqueEntity">{{validator.errorMessage}}</mat-error>
        </div>

     <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
        <mat-form-field appearance="outline" style="width:100%">
          <textarea  matInput placeholder="Description" formControlName="description"></textarea>
        </mat-form-field>
      </div>

				<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
				<button [disabled]="!Entity.valid"  mat-flat-button class="btn" (click)="createEntity()">Submit</button>
				<button mat-flat-button class="btn" (click)="backentityList()">Cancel</button>
        </div>
			</form>
		</div>
</div>
</div>

</div>
